import { useContext, useMemo } from "react";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { createTheme, useTheme } from "@mui/material/styles";
import DocumentContext from "pages/document/document-context";
import { documentTenantDataSelector } from "store/documents/selectors";
import {
  buildDocumentThemePalette,
  resolveTenantBrandingTheme
} from "pages/app/organization/settings/document/general/themeUtils";

const useTenantBrandingTheme = ({ enabled = true } = {}) => {
  const baseTheme = useTheme();
  const documentContextValue = useContext(DocumentContext);
  const ctx = documentContextValue && typeof documentContextValue === "object" ? documentContextValue : {};
  const tenantSettingsState = useSelector(documentTenantDataSelector, isEqual);
  const tenantSettings = tenantSettingsState?.data;

  const brandingSource = useMemo(
    () =>
      resolveTenantBrandingTheme(
        tenantSettings,
        ctx.data?.tenantSettings,
        ctx.data?.organizationData,
        ctx.theme || ctx.data?.theme
      ),
    [tenantSettings, ctx.data?.tenantSettings, ctx.data?.organizationData, ctx.theme, ctx.data?.theme]
  );

  return useMemo(() => {
    if (!enabled || !brandingSource) {
      return baseTheme;
    }

    const { primary } = buildDocumentThemePalette(brandingSource, {
      primary: baseTheme.palette.primary
    });

    // Overlay brand colors only — keep the ambient light/dark background.
    return createTheme(baseTheme, {
      palette: { primary }
    });
  }, [enabled, baseTheme, brandingSource]);
};

export default useTenantBrandingTheme;
